export default __webpack_public_path__ + "static/media/math-icon-k-2.e653a617e6434852d93921d6ba3f6bd1.svg";